import { CalendarClock } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CONFIG } from "@/config";
import { RegistrationForm } from "@/components/RegistrationForm";

// Popup that appears when the viewer presses play on the cover
export const RegistrationDialog = ({ open, onClose, onRegistered }) => {
  const g = CONFIG.gate;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-w-md rounded-3xl border-[#282C24] p-6 sm:p-8 w-[calc(100%-1.5rem)]" data-testid="registration-dialog">
        <DialogHeader className="text-left space-y-2">
          <span className="eyebrow">{g.badge}</span>
          <DialogTitle className="font-display text-2xl sm:text-3xl font-semibold tracking-tight text-[#F4F5F2]">{g.formTitle}</DialogTitle>
          <DialogDescription className="text-sm text-[#A3A89E]">{g.formSubtitle}</DialogDescription>
          <p className="inline-flex items-center gap-2 text-xs sm:text-sm text-[#D9B25F]" data-testid="dialog-expiry-notice">
            <CalendarClock className="h-3.5 w-3.5 shrink-0" />
            {g.expiryText}
          </p>
        </DialogHeader>
        <RegistrationForm onRegistered={onRegistered} embedded />
      </DialogContent>
    </Dialog>
  );
};
